import './App.css';
import Header from './components/Header/Header';
import MainContent from './components/MainContent/Maincontent';
import Footer from './components/Footer/Footer';
import React from 'react';

function App() {
  return (
    <div className="App">
    <Header />
    <MainContent />
    <Footer />
  </div>
  );
}

export default App;
